import { Classes, Colors } from "@blueprintjs/core";
import { Link } from "react-router";

import { isCoach } from "@/components/helpers/workspace/permissions";
import { Box } from "@/components/layout/flexbox";
import { ExecSvg } from "@/components/pieces/icons/svg/exec";
import { PlacementSvg } from "@/components/pieces/icons/svg/placement";
import { BRAND_PURPLE } from "@/css/constants";
import { Workspace } from "@/types/workspaces";

export const LOGO_HEIGHT = 70;

interface WorkspaceMenuLogoProps {
  workspace?: Workspace;
  iconSize?: number;
  fitSize?: boolean;
  margin?: number;
  isLink?: boolean;
  loading?: boolean;
}

export function WorkspaceMenuLogo({
  workspace,
  iconSize = LOGO_HEIGHT,
  fitSize = false,
  margin = 12,
  isLink = true,
  loading = false,
}: WorkspaceMenuLogoProps) {
  const LogoComponent = IS_EXEC ? ExecSvg : PlacementSvg;

  const logo = (
    <Box
      height={iconSize}
      width={fitSize ? iconSize : "auto"}
      m={margin}
      className={loading ? Classes.SKELETON : undefined}
    >
      {workspace?.logo ? (
        <img
          src={workspace.logo}
          style={{
            objectFit: "contain",
            maxWidth: 220,
            width: "100%",
            height: "100%",
          }}
        />
      ) : (
        <LogoComponent
          size={iconSize ? iconSize : LOGO_HEIGHT - 10}
          color={workspace ? Colors.LIGHT_GRAY3 : BRAND_PURPLE}
        />
      )}
    </Box>
  );
  return isLink ? (
    <Link to={isCoach() ? "/clients" : "/dashboard"}>{logo}</Link>
  ) : (
    logo
  );
}
